import React from "react";
import Chapter from "@/components/landing/Chapter";
import Reveal from "@/components/landing/Reveal";

const points = [
  "Eres empresaria, CEO, directiva, fundadora o propietaria de negocio.",
  "Has construido una trayectoria sólida, pero sientes que ha llegado el momento de liderar con más visión, foco y autoridad.",
  "Quieres rodearte de mujeres que están tomando decisiones, sosteniendo equipos, haciendo crecer negocios y abriendo conversaciones de mayor nivel.",
  "Necesitas fortalecer tu comunicación, tu criterio empresarial, tus alianzas y tu capacidad de influencia.",
  "Quieres dejar de vivir la visibilidad como exposición y empezar a convertirla en una herramienta real de liderazgo.",
];

const ForWhom = () => {
  return (
    <section
      id="para-quien"
      data-testid="forwhom-section"
      className="bg-[#FAF8F3]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32 lg:py-40">
        <div className="grid grid-cols-12 gap-8 md:gap-14">
          <div className="col-span-12 lg:col-span-5">
            <Reveal>
              <Chapter number="04" label="Para quién" />
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-[#3F403A]">
                Esta edición<br />
                <span className="italic text-[#63846F]">es para ti si…</span>
              </h2>
            </Reveal>
          </div>

          <div className="col-span-12 lg:col-span-7">
            <ul className="divide-y divide-[#3F403A]/12 border-t border-b border-[#3F403A]/12">
              {points.map((p, i) => (
                <Reveal
                  as="li"
                  key={i}
                  delay={i * 90}
                  className="py-6 md:py-8 flex gap-6 items-start"
                  data-testid={`forwhom-point-${i}`}
                >
                  <span className="mt-2 font-serif italic text-[#63846F] text-lg md:text-xl w-8 shrink-0">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <p className="font-sans text-base md:text-lg leading-relaxed text-[#3F403A]/90">
                    {p}
                  </p>
                </Reveal>
              ))}
            </ul>

            <Reveal delay={180}>
              <blockquote
                className="mt-12 md:mt-16 border-l-2 border-[#63846F] pl-6 md:pl-8"
                data-testid="forwhom-quote"
              >
                <p className="font-serif italic text-2xl md:text-3xl lg:text-4xl leading-snug text-[#3F403A]">
                  No vienes solo a inspirarte. Vienes a
                  <span className="text-[#63846F]"> pensar, decidir y liderar</span>
                  {" "}desde otro lugar.
                </p>
              </blockquote>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForWhom;
